import { FocusEntity } from "navigation/FocusEntity";

export default {
  [FocusEntity.NONE]: [],
  [FocusEntity.APP_STATE]: [],
  [FocusEntity.CANVAS]: [],
  [FocusEntity.QUERY_ADD]: [],
  [FocusEntity.API]: [],
  [FocusEntity.LIBRARY]: [],
  [FocusEntity.SETTINGS]: [],
  [FocusEntity.DATASOURCE_CREATE]: [],
  [FocusEntity.DATASOURCE_LIST]: [],
  [FocusEntity.DATASOURCE]: [],
  [FocusEntity.JS_OBJECT]: [],
  [FocusEntity.QUERY]: [],
  [FocusEntity.WIDGET]: [],
  [FocusEntity.DEBUGGER]: [],
  [FocusEntity.QUERY_LIST]: [],
  [FocusEntity.JS_OBJECT_LIST]: [],
  [FocusEntity.WIDGET_LIST]: [],
  [FocusEntity.EDITOR]: [],
};
